module.exports = __webpack_public_path__ + "img/slide2-mb.ac13c4f2.png";